export const linktivityPrimary = '#00A17B';
export const linktivitySecondary = '#00838F';
export const linktivityAccent = '#FFB300';
// export const linktivityAccent = '#E14658';
